import { useToast, Box, Button } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { useWorkspaceStore } from '../../panels/use-workspace-store';
import { useCreateQueueCreationPanel } from '../hooks/use-create-queue-creation-panel';

export const QueueCreationButton = observer(function QueueCreationButton(): React.ReactElement {
    const createQueueCreationPanel = useCreateQueueCreationPanel();
    const workspacePanelsStore = useWorkspaceStore();
    const toast = useToast();
    return (
        <Box ml="10">
            <Button
                type="button"
                size="sm"
                variant="outline"
                onClick={() => {
                    if (
                        workspacePanelsStore
                            .getActivePanels()
                            .filter((panel) => panel.workspacePanelType === 'QUEUE').length >= 10
                    ) {
                        toast({
                            status: 'default',
                            description:
                                'Cannot open another Queue Panel. No more than 10 Queue Panels may be open at once.',
                        });
                    } else {
                        createQueueCreationPanel();
                    }
                }}
            >
                New Queue
            </Button>
        </Box>
    );
});
